import { request } from '../@utils'
const ShopService = {
  getList: () => {
    return request.post('common/store/list')
  },
  addFileTask: async params => {
    const res = await request.post('/product/merchant-product/add-file-task', { data: params })
    return res
  },
}
export default ShopService
